(function () {
  var KEY = 'qa-bird-species';
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function getSel() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!raw || !raw.s || !raw.t || (Date.now() - raw.t) > TTL) { return []; }
      return raw.s;
    } catch (e) { return []; }
  }
  function setSel(list) {
    try {
      if (list.length) { localStorage.setItem(KEY, JSON.stringify({ s: list, t: Date.now() })); }
      else { localStorage.removeItem(KEY); }
    } catch (e) {}
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function fmt(list) {
    if (list.length === 1) return list[0];
    if (list.length === 2) return list[0] + ' and ' + list[1];
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }
  function intersect(a, b) { return a.filter(function (x) { return b.indexOf(x) > -1; }); }

  function confetti(anchor) {
    if (reducedMotion || !anchor) return;
    var r = anchor.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var colors = ['#5cc2b6', '#22c55e', '#fcda5a', '#ff9f1c', '#ff2d41', '#00a6ed'];
    for (var i = 0; i < 32; i++) {
      var p = document.createElement('span');
      p.className = 'qa-confetti';
      var ang = Math.random() * Math.PI * 2;
      var dist = 60 + Math.random() * 90;
      var dx = Math.cos(ang) * dist;
      var dy = Math.abs(Math.sin(ang)) * dist * 0.4 + 120 + Math.random() * 80;
      p.style.left = cx + 'px';
      p.style.top = cy + 'px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--qa-dx', dx.toFixed(0) + 'px');
      p.style.setProperty('--qa-dy', dy.toFixed(0) + 'px');
      p.style.setProperty('--qa-rot', (Math.random() * 720 - 360).toFixed(0) + 'deg');
      p.style.animationDuration = (700 + Math.random() * 500).toFixed(0) + 'ms';
      p.addEventListener('animationend', function () { this.remove(); });
      document.body.appendChild(p);
    }
  }

  function updateTicks() {
    var cards = document.querySelectorAll('[data-qa-species]');
    if (!cards.length) return;
    var sel = getSel();
    cards.forEach(function (card) {
      var badge = card.querySelector('.qa-tick');
      if (!badge) return;
      var sp = (card.getAttribute('data-qa-species') || '').split('|').filter(Boolean);
      badge.hidden = !(sel.length && intersect(sel, sp).length);
      if (card.hasAttribute('data-qa-warn')) { badge.classList.add('qa-tick--amber'); }
      else { badge.classList.remove('qa-tick--amber'); }
    });
  }

  function initSelector() {
    var root = document.querySelector('[data-qa-selector]');
    if (!root) return;
    var dataEl = root.querySelector('[data-qa-product-species]');
    var suits = [];
    try { suits = JSON.parse(dataEl.textContent); } catch (e) {}
    var warn = root.hasAttribute('data-qa-warn');
    var details = root.querySelector('details');
    var heading = root.querySelector('[data-qa-heading]');
    var iconAsk = root.querySelector('[data-qa-icon-ask]');
    var iconYes = root.querySelector('[data-qa-icon-yes]');

    var CHANGE = ' <span class="qa-sp__action">Change</span>';

    function render() {
      var sel = getSel();
      root.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = sel.indexOf(cb.value) > -1; });
      if (!sel.length) {
        iconAsk.hidden = false;
        iconYes.hidden = true;
        heading.innerHTML = '<span class="qa-sp__action">Choose</span> the bird species you’re shopping for';
        return;
      }
      var m = intersect(sel, suits);
      if (!m.length) {
        iconAsk.hidden = false;
        iconYes.hidden = true;
        heading.innerHTML = 'You’re shopping for ' + esc(fmt(sel)) + CHANGE;
        return;
      }
      iconAsk.hidden = true;
      iconYes.hidden = false;
      if (warn) {
        heading.innerHTML = 'Check actual sizing for your ' + esc(fmt(m)) + CHANGE;
      } else {
        heading.innerHTML = 'Suitable for your ' + esc(fmt(m)) + CHANGE;
      }
    }

    function wiggle() {
      if (reducedMotion || iconAsk.hidden || details.open) return;
      iconAsk.classList.add('qa-sp__icon--wiggle');
      setTimeout(function () { iconAsk.classList.remove('qa-sp__icon--wiggle'); }, 1000);
    }
    setTimeout(wiggle, 2500);
    setInterval(wiggle, 7000);

    var clearBtn = root.querySelector('[data-qa-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        root.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = false; });
      });
    }

    var confirmBtn = root.querySelector('[data-qa-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var sel = [];
        root.querySelectorAll('input[type=checkbox]').forEach(function (cb) { if (cb.checked) sel.push(cb.value); });
        setSel(sel);
        if (details) details.removeAttribute('open');
        render();
        updateTicks();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Bird species': sel.length ? sel.join(', ') : '' } })
        }).catch(function () {});
        if (sel.length) {
          try {
            var kl = (window.klaviyo = window.klaviyo || []);
            var matched = intersect(sel, suits);
            kl.push(['identify', { 'Bird species': sel.join(', ') }]);
            kl.push(['track', 'Species Picker Confirmed', {
              'Bird species': sel.join(', '),
              'Species list': sel,
              'Species count': sel.length,
              'Product': root.getAttribute('data-qa-product-title') || '',
              'Product handle': root.getAttribute('data-qa-product-handle') || '',
              'Product suits': suits,
              'Suitable': matched.length > 0,
              'Size check flagged': warn
            }]);
          } catch (e) {}
        }
        var buyEl = document.querySelector('variant-picker') || document.querySelector('button[name="add"]');
        var scrollEl = root;
        if (buyEl) { scrollEl = buyEl.closest('.product-info__block') || buyEl; }
        scrollEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (sel.length && intersect(sel, suits).length) {
          setTimeout(function () { confetti(iconYes); }, 700);
        }
      });
    }

    render();
  }

  function init() {
    initSelector();
    updateTicks();
    var moTimer = null;
    var mo = new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () { moTimer = null; updateTicks(); }, 300);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();